document.addEventListener('DOMContentLoaded', () => {
    new Swiper('.mediaSwiper', {
        slidesPerView: 'auto',
        spaceBetween: 16,
        allowTouchMove: true,
        navigation: {
            prevEl: '.media-prev',
            nextEl: '.media-next',
        },
        pagination: {
            el: '.media-pagination',
            clickable: true,
        },
        breakpoints: {
            1024: {
                slidesPerView: 3,
                spaceBetween: 24,
            }
        },
    });
});
